const CONFIG_KEY_BASE = 'experiments';
const ERROR_DOMAIN_BASE = 'experiments';
export { CONFIG_KEY_BASE, ERROR_DOMAIN_BASE };
